module.exports = __webpack_public_path__ + "static/filters-background-3534bf7f127d8fca05f6adc7ffcaee45.jpg";